/**
 * The events table: select all header plus one row per visible event. It
 * scrolls inside a screen-height box with the header pinned, so the submit
 * buttons below stay in reach on long lists.
 */

import React from 'react';
import { Checkbox, Table } from 'semantic-ui-react';
import { I18n, Translate } from 'react-redux-i18n';
import { i18nKeys } from '../constants';
import { HeaderCheckboxState } from '../helpers';
import { OrganizationEvent } from '../types';
import EventTableRow from './EventTableRow';
import styles from '../AddOrganizationToEvents.module.css';

interface EventTableProps {
  events: OrganizationEvent[];
  selected: Set<number>;
  header: HeaderCheckboxState;
  disabled: boolean;
  onToggleAll: () => void;
  onToggle: (event: OrganizationEvent, isSelected: boolean) => void;
}

const EventTable: React.FC<EventTableProps> = ({
  events,
  selected,
  header,
  disabled,
  onToggleAll,
  onToggle
}) => (
  <div className={styles.tableScroll}>
    <Table compact celled>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell collapsing>
            <Checkbox
              title={I18n.t(i18nKeys.EVENTS.SELECT_ALL)}
              checked={header.checked}
              indeterminate={header.indeterminate}
              disabled={disabled}
              onChange={onToggleAll}
            />
          </Table.HeaderCell>
          <Table.HeaderCell>
            <Translate value={i18nKeys.EVENTS.COLUMN_NAME} />
          </Table.HeaderCell>
          <Table.HeaderCell>
            <Translate value={i18nKeys.EVENTS.COLUMN_LOCATION} />
          </Table.HeaderCell>
          <Table.HeaderCell collapsing textAlign="center">
            <Translate value={i18nKeys.EVENTS.COLUMN_ORGANIZATIONS} />
          </Table.HeaderCell>
          <Table.HeaderCell collapsing>
            <Translate value={i18nKeys.EVENTS.COLUMN_DATE} />
          </Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {events.length === 0 && (
          <Table.Row>
            <Table.Cell colSpan={5} textAlign="center">
              <Translate value={i18nKeys.EVENTS.NONE} />
            </Table.Cell>
          </Table.Row>
        )}
        {events.map((event) => (
          <EventTableRow
            key={event.id}
            event={event}
            isPicked={selected.has(event.id)}
            disabled={disabled}
            onToggle={onToggle}
          />
        ))}
      </Table.Body>
    </Table>
  </div>
);

export default EventTable;
